<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៤.ក ខ គ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៤.ឃ ង
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <staffsal :data="sta_sal" :title="title[1]" />
            <stafftwoshift :data="sta_mug" :title="title[3]" />
          </div>
          <div><stafftente :data="sta_fun" :title="title[2]" /></div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <staffmulgrade :data="sta_mup" :cur_cod="cur_cod" :title="title[4]" />
        <staffedu :data="sta_tra" :title="title[5]" />
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import staffSalary from "@/components/ascf/sharedCom/staffSalary.vue";
import staffTenTe from "@/components/ascf/pri/staffTenTe.vue";
import staffEducation from "@/components/ascf/sharedCom/staffEducation.vue";
import staffTwoShift from "@/components/ascf/pri/staffTwoShift.vue";
import staffMGrade from "@/components/ascf/pri/staffMultiGrade.vue";

export default {
  props: [
    "title",
    "sta_sal",
    "sta_fun",
    "sta_mug",
    "sta_mup",
    "sta_tra",
    "cur_cod",
  ],
  components: {
    staffsal: staffSalary,
    stafftente: staffTenTe,
    stafftwoshift: staffTwoShift,
    staffmulgrade: staffMGrade,
    staffedu: staffEducation,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.col {
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>